import React, { Component } from "react";
import {
  Container,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  withStyles,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import { GetData } from "../../api/service";
import { TeacherCard } from "../Department/FacultyPage";
import { allStyles } from "../Department/FacultyPage";

class ListOfHods extends Component {
  state = {
    data: [],
    isDataLoaded: false,
  };

  componentDidMount() {
    this.fetchHods();
  }

  fetchHods = () => {
    GetData(`/gethods`).then((res) => {
      this.setState({
        data: res,
        isDataLoaded: true,
      });
    });
  };

  render() {
    const { classes } = this.props;
    const { data, isDataLoaded } = this.state;

    return (
      <Container className="mb-5">
        <Typography
          variant="h5"
          style={{ margin: "1em 0", fontWeight: 700 }}
          gutterBottom
        >
          List of HODs
        </Typography>

        {isDataLoaded ? (
          data.map((dept, index) => (
            <Accordion key={index} defaultExpanded={index === 0}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography style={{ fontWeight: 600 }}>
                  {dept.dept_name}
                </Typography>
              </AccordionSummary>

              <AccordionDetails>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 20, width: "100%" }}>
                  {dept.data.map((teacher, i) => (
                    <TeacherCard
                      key={i}
                      {...teacher}
                      styles={classes}
                    />
                  ))}
                </div>
              </AccordionDetails>
            </Accordion>
          ))
        ) : (
          `Loading . . . .`
        )}
      </Container>
    );
  }
}

export default withStyles(allStyles)(ListOfHods);